export const SERVICES = [
  {
    slug: "retour-hopital",
    title: "Retour de l'hôpital post-accouchement",
    price: "60€",
    duration: "1h30",
    badge: "Dans les 2 premiers mois",
    visio: true,
    short: "Un soutien précieux pour les tout premiers jours à la maison.",
    description:
      "Un accompagnement pour comprendre votre bébé, vous sentir soutenu·e et repartir avec des repères concrets pour vos tout premiers jours de parents à la maison.",
    points: [
      "Bases de compréhension du bébé",
      "Écoute individuelle",
      "Conseils pour les premiers jours",
      "Soutien émotionnel",
    ],
  },
  {
    slug: "bilan-familial",
    title: "Bilan familial",
    subtitle: "Première rencontre",
    price: "50€",
    duration: "1h",
    badge: "Première rencontre",
    visio: true,
    short: "Un premier temps ensemble pour poser les bases.",
    description:
      "Un temps privilégié pour écouter votre histoire, observer votre enfant et vous proposer les premières pistes d'accompagnement adaptées à votre famille.",
    points: [
      "Temps d'échange approfondi avec vous",
      "Recueil de votre histoire familiale et de vos préoccupations",
      "Première observation globale de l'enfant",
      "Pistes d'actions et proposition d'un plan d'accompagnement personnalisé",
    ],
  },
  {
    slug: "analyse-approfondie",
    title: "Analyse approfondie",
    subtitle: "Plusieurs thématiques",
    price: "50€/séance",
    duration: "1h · min. 3 séances",
    badge: "Suivi thématique",
    visio: false,
    short: "Pour saisir tous les enjeux et difficultés rencontrés.",
    description:
      "Un suivi en profondeur pour observer votre enfant dans son quotidien, comprendre le fonctionnement familial et repérer les déclencheurs — puis mettre en place un plan d'actions concret.",
    points: [
      "Observation de l'enfant dans son environnement quotidien approfondie",
      "Analyse du fonctionnement familial",
      "Repérage des déclencheurs (colères, oppositions, difficultés)",
      "Plan d'actions concret, accompagné et soutenu lors de sa mise en place",
    ],
  },
  {
    slug: "accompagnement-parental",
    title: "Plan d'action",
    subtitle: "Séances d'accompagnement parental",
    price: "50€/séance",
    duration: "1h · min. 3 séances",
    badge: "Suivi régulier",
    visio: true,
    short: "Avancer pas à pas, avec des outils concrets.",
    description:
      "Des séances régulières pour mettre en place, dans la durée, des routines et des repères adaptés à votre situation — avec un vrai soutien lors des actions concrètes.",
    points: [
      "Conseils adaptés à votre situation",
      "Outils concrets pour les routines et la gestion du quotidien",
      "Soutien lors des actions concrètes à mettre en place",
    ],
  },
  {
    slug: "atelier-eveil",
    title: "Atelier éveil",
    subtitle: "Moment enfant et parent",
    price: "50€/séance",
    duration: "1h",
    badge: "Parent · enfant",
    visio: false,
    short: "Un moment complice, un temps précieux à deux.",
    description:
      "Un temps privilégié parent-enfant pour soutenir le développement (motricité, langage, autonomie), s'initier au jeu ensemble et apprendre à mieux se comprendre.",
    points: [
      "Soutien au développement (motricité, langage, autonomie) avec activités d'éveil adaptées",
      "Temps d'échange avec vous et avec votre enfant",
      "S'initier au jeu avec son enfant, apprendre à se comprendre et jouer ensemble",
    ],
  },
  {
    slug: "forfait-accelere",
    title: "Forfait d'accompagnement Accéléré",
    price: "45€/h",
    duration: "4 séances de 3h sur 5 jours consécutifs · 12h au total",
    badge: "Intensif",
    visio: false,
    short: "Aller vite et en profondeur, sur une semaine.",
    description:
      "Un accompagnement intensif sur une semaine, avec un suivi resserré et personnalisé, et des ajustements progressifs selon l'évolution de la situation.",
    points: [
      "Suivi plus personnalisé et régulier",
      "Ajustement selon l'évolution de la situation, progressif",
      "Soutien lors de la mise en place de toutes les actions et suivi de celles-ci immédiats",
      "Outils concrets pour les routines et la gestion du quotidien",
      "Conseils adaptés à votre situation",
    ],
  },
];

export const NEEDS = [
  {
    key: "emotions",
    emoji: "🌈",
    title: "Tempête émotionnelle",
    text:
      "Votre enfant a du mal à gérer ses émotions : il se met souvent en colère ou pleure facilement, et vous ne savez pas comment l'accompagner.",
  },
  {
    key: "tensions",
    emoji: "⏳",
    title: "Quotidien sous tensions",
    text:
      "Vous avez des questions ou simplement besoin d'une écoute sur votre parentalité sans vous sentir jugés et en toute discrétion. Vous avez besoin de sérénité. Et/ou vous manquez de temps ou de repères et vous avez besoin de conseils pratiques afin d'organiser le quotidien et les routines pour faciliter le quotidien.",
  },
  {
    key: "eveil",
    emoji: "🎨",
    title: "Éveil et jeu",
    text:
      "Vous souhaitez stimuler son éveil : proposer des jeux, activités ou ateliers adaptés à son âge afin de développer sa motricité, son langage, sa créativité ou son autonomie.",
  },
  {
    key: "cap",
    emoji: "🏠",
    title: "Cap de vie",
    text:
      "Vous traversez un grand changement de vie (l'arrivée d'un frère ou d'une sœur, séparation, déménagement) et vous souhaitez accompagner votre enfant sereinement.",
  },
  {
    key: "comprendre",
    emoji: "💡",
    title: "Mieux comprendre",
    text:
      "Vous voulez mieux comprendre votre enfant : observer son comportement, ses besoins, ses réactions et trouver des réponses à vos questions concernant son développement et les pédagogies.",
  },
  {
    key: "prevenir",
    emoji: "🛡️",
    title: "Prévenir, agir tôt",
    text:
      "Vous préférez agir tôt, dès les premières difficultés, pour éviter qu'elles ne s'installent et ne nécessitent plus tard un accompagnement médical ou psychologique plus lourd.",
  },
];

export const CONTACT_INFO = {
  phone: "06 95 30 09 93",
  phoneRaw: "+33695300993",
  email: "lea.parentalite@gmail.com",
  hours: "Lundi au samedi, 8h — 18h",
  zone: "Dijon & ses agglomérations (max. 45 min)",
  firstCall: "1er appel gratuit pour établir un premier contact.",
};

export const TIME_SLOTS = [
  "08:00", "09:00", "10:00", "11:00",
  "13:00", "14:00", "15:00", "16:00", "17:00",
];

export const TESTIMONIALS = [
  {
    name: "Camille & Antoine",
    role: "Parents d'Inès, 3 mois",
    text:
      "Léa est venue chez nous quelques jours après notre retour de la maternité. Sa douceur et ses conseils nous ont littéralement transformé·es. On respire enfin.",
  },
  {
    name: "Sophie",
    role: "Maman de Léon, 2 ans",
    text:
      "Les colères de Léon nous épuisaient. En 4 séances, nous avons mis en place des repères concrets. Léa écoute sans juger, c'est inestimable.",
  },
  {
    name: "Famille Moreau",
    role: "Trois enfants (1, 4 et 6 ans)",
    text:
      "Le forfait accéléré nous a permis de remettre du calme à la maison en une semaine. On se sent enfin alignés en tant que parents.",
  },
];

// Articles de blog — modifiables. Léa fournira ses propres textes pour le référencement.
export const BLOG_POSTS = [
  {
    slug: "gerer-les-coleres-du-jeune-enfant",
    title: "Comprendre et accompagner les colères du jeune enfant",
    date: "2026-01-15",
    excerpt:
      "Les fameuses « crises » ne sont pas des caprices : elles expriment un cerveau encore en construction. Voici comment accueillir l'émotion sans céder, et poser un cadre rassurant.",
    tag: "Émotions",
  },
  {
    slug: "amenager-un-espace-favorisant-l-autonomie",
    title: "Aménager la maison pour favoriser l'autonomie de votre enfant",
    date: "2026-02-02",
    excerpt:
      "Un environnement pensé à hauteur d'enfant change tout. Quelques principes simples, inspirés de ma formation FM2J, pour un espace de jeu qui invite à explorer en sécurité.",
    tag: "Aménagement",
  },
  {
    slug: "instaurer-des-routines-apaisantes",
    title: "Instaurer des routines qui apaisent le quotidien",
    date: "2026-02-20",
    excerpt:
      "Le rituel du coucher, du repas ou du départ le matin : des repères stables rassurent l'enfant et allègent la charge des parents. Comment les mettre en place en douceur.",
    tag: "Quotidien",
  },
];
